.c-vacation-calculator-watermark {
  display: none;
}@media print {.c-vacation-calculator-watermark {
    display: block;
  }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9jb21wb25lbnRzL3ZhY2F0aW9uX2NhbGN1bGF0b3Ivd2F0ZXJtYXJrX2NvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFhO0FBR2YsQ0FERSxjQUFBO0lBQUE7RUFBa0I7QUFBQSIsImZpbGUiOiJhcHAvY29tcG9uZW50cy92YWNhdGlvbl9jYWxjdWxhdG9yL3dhdGVybWFya19jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmMtdmFjYXRpb24tY2FsY3VsYXRvci13YXRlcm1hcmsge1xuICBkaXNwbGF5OiBub25lO1xuXG4gIEBhcHBseSBwcmludDpibG9jaztcbn1cbiJdfQ== */